import { useState, useEffect, useRef } from "react";
import { autofillOffProps } from "../../../shared/autofillOffProps";

/**
 * Filtre çekmecesinde tüm arama alanları: ilk odakta readOnly kalkar, Chrome adres/ad önerisi azalır.
 */
export default function FilterSearchInput({
    value,
    onChange,
    fieldKey,
    drawerOpen,
    className = "filter-input",
}) {
    const [editable, setEditable] = useState(false);
    const prevDrawerRef = useRef(drawerOpen);

    useEffect(() => {
        const was = prevDrawerRef.current;
        prevDrawerRef.current = drawerOpen;
        if (drawerOpen && !was) setEditable(false);
    }, [drawerOpen]);

    return (
        <input
            type="search"
            className={className}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            readOnly={!editable}
            onMouseDown={() => setEditable(true)}
            onFocus={() => setEditable(true)}
            name={`ftx-q-${fieldKey}`}
            id={`filter-field-${fieldKey}`}
            {...autofillOffProps}
        />
    );
}
